<script setup>
    import AlertList from '@/components/shared/AlertList.vue'
    import Footer from '@/layouts/partials/Footer.vue'
    import Sidebar from '@/layouts/partials/Sidebar.vue'
    import Topbar from '@/layouts/partials/Topbar.vue'
</script>

<template>
    <Sidebar />

    <main class="relative min-h-screen pt-10 lg:pt-32 xl:pl-72">
        <Topbar />

        <div class="container mx-auto grid w-full grid-cols-1 px-4 sm:px-6 lg:px-8">
            <slot />

            <AlertList />
        </div>
    </main>

    <Footer />
</template>
